function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .MuiOutlinedInput-root {\n    width: 100%;\n  }\n  .MuiOutlinedInput-input {\n    padding: 12px;\n  }\n  label {\n    color: ", ";\n    margin-bottom: 8px;\n    display: inline-block;\n    &.small {\n      font-size: ", ";\n    }\n  }\n  .input {\n    background: transparent;\n    border: none;\n    height: 100%;\n    width: 100%;\n    padding: 11px 0;\n    font-size: ", ";\n    color: ", ";\n  }\n  .root {\n    border-radius: 2px;\n    width: 100%;\n    box-sizing: border-box;\n    padding-left: 15px;\n    padding-right: 15px;\n    margin-bottom: 20px;\n    color: ", ";\n    &:focus {\n      & .notchedOutline {\n        border: none;\n      }\n    }\n    &:hover {\n      & .notchedOutline {\n        border-color: ", ";\n      }\n    }\n    &.Mui-focused {\n      & .notchedOutline {\n        border: 1px solid ", ";\n      }\n    }\n    &.Mui-disabled {\n      pointer-events: none;\n      opacity: 0.4;\n    }\n    .MuiTypography-root {\n      font-size: ", ";\n      color: ", ";\n    }\n  }\n  .notchedOutline {\n    border: 1px solid ", ";\n    &:focus {\n      border: 1px solid ", ";\n      outline: none;\n    }\n  }\n  .embedded-input {\n    &.root {\n      background-color: ", ";\n      border-radius: 6px;\n    }\n    .MuiOutlinedInput-notchedOutline {\n      border: 0;\n    }\n  }\n  .error {\n    .notchedOutline {\n      border: 1px solid ", ";\n      &:focus {\n        border: 1px solid ", ";\n      }\n    }\n    &.Mui-focused {\n      & .notchedOutline {\n        border: 1px solid ", ";\n      }\n    }\n    &.root {\n      &:hover {\n        & .notchedOutline {\n          border-color: ", ";\n        }\n      }\n    }\n  }\n  .small {\n    .input {\n      padding: 5px 0;\n      font-size: ", ";\n    }\n    &.root {\n      padding-left: 8px;\n      padding-right: 8px;\n    }\n    .MuiTypography-root {\n      font-size: ", ";\n    }\n  }\n  .hide-border {\n    .MuiOutlinedInput-notchedOutline {\n      border: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FilledInput from '@material-ui/core/FilledInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import { StylesProvider } from '@material-ui/styles';
import { defaultTheme } from '../../../utils';
var TextInputContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.textColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typeScale.copyrightText;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typeScale.regular;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.textColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.textColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryBorder;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.primaryBorderActive;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typeScale.regular;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.textColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.primaryBorder;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.primaryBorderActive;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.textFieldBackground;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.status.errorColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.status.errorColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.status.errorColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.status.errorColor;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typeScale.copyrightText;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typeScale.copyrightText;
});

var TextInput = function TextInput(_ref19) {
  var _ref20;

  var inputRef = _ref19.inputRef,
      name = _ref19.name,
      icon = _ref19.icon,
      text = _ref19.text,
      mask = _ref19.mask,
      styleClass = _ref19.styleClass,
      position = _ref19.position,
      label = _ref19.label,
      size = _ref19.size,
      variant = _ref19.variant,
      rest = _objectWithoutPropertiesLoose(_ref19, ["inputRef", "name", "icon", "text", "mask", "styleClass", "position", "label", "size", "variant"]);

  var muiClasses = {
    outlined: {
      root: 'root',
      input: 'input',
      notchedOutline: 'notchedOutline'
    },
    embeddedInput: {
      root: 'root',
      input: 'input'
    }
  };
  var variantClasses = {
    outlined: '',
    embeddedInput: 'embedded-input',
    hideBorder: 'hide-border'
  };
  var inputPrefix = icon || text ? (_ref20 = {}, _ref20[position === 'start' ? 'startAdornment' : 'endAdornment'] = /*#__PURE__*/React.createElement(InputAdornment, {
    position: position
  }, icon ? /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "icon"
  }) : text || ''), _ref20) : null;
  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(TextInputContainer, rest, label ? /*#__PURE__*/React.createElement("label", {
    className: size
  }, label) : null, mask && mask.length ? /*#__PURE__*/React.createElement(MaskedInput, _extends({
    mask: mask,
    name: name
  }, rest, {
    render: function render(ref, props) {
      return /*#__PURE__*/React.createElement("input", _extends({
        className: "notchedOutline input root " + size + " " + styleClass,
        ref: ref
      }, props));
    }
  })) : /*#__PURE__*/React.createElement(OutlinedInput, _extends({}, inputPrefix, {
    classes: _extends({}, muiClasses[variant]),
    className: size + " " + styleClass + " " + variantClasses[variant],
    name: name,
    inputRef: inputRef
  }, rest))));
};

TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  inputRef: PropTypes.func,
  name: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  mask: PropTypes.array,
  styleClass: PropTypes.string,
  position: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string
} : {};
TextInput.defaultProps = {
  theme: defaultTheme,
  icon: '',
  text: '',
  inputRef: function inputRef() {},
  mask: [],
  styleClass: '',
  position: 'start',
  label: '',
  size: 'normal',
  variant: 'outlined'
};
export default TextInput;